import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import dayjs from 'dayjs';

import { actions } from 'features/bonusProgram';
import { itemsOnPage } from 'features/bonusProgram/data';

import { convertGiftRequests } from './convertGiftRequests';

const useGiftRequests = () => {
  const dispatch = useDispatch();
  const { items, count } = useSelector(s => s.bonusProgram.giftRequests, shallowEqual);

  const [state, setState] = useState({
    page: 0,
    itemsOnPage,
    statuses: ['new', 'processing', 'sent', 'completed'],
    beginDate: new Date(dayjs().add(-3, 'day')),
    endDate: new Date(),
    activeDay: '',
    username: '',
  });

  const [addressModalOpen, setAddressModalOpen] = useState('');

  const handlePageChange = page => setState(ps => ({ ...ps, page }));
  const handleItemsOnPageChange = itemsOnPage => setState(ps => ({ ...ps, itemsOnPage }));
  const handleUsernameChange = username => setState(ps => ({ ...ps, username }));
  const handleBeginDateChange = beginDate => setState(ps => ({ ...ps, beginDate }));
  const handleEndDateChange = endDate => setState(ps => ({ ...ps, endDate }));
  const handleDayChange = activeDay => {
    setState(ps => ({
      ...ps,
      beginDate: activeDay.value,
      endDate: activeDay.value2,
      activeDay,
    }));
  };

  const handleStatusChange = status => {
    setState(ps => {
      const { statuses } = ps;
      const newStatuses = statuses.includes(status) ? [...statuses.filter(v => v !== status)] : [...statuses, status];

      return {
        ...ps,
        statuses: newStatuses,
      };
    });
  };

  const handleFormSubmit = e => {
    e.preventDefault();
    dispatch(actions.getGiftRequests(convertGiftRequests(state)));
  };

  const handleRequestChange = (item, selectItems) => {
    const status = selectItems.filter(t => t.active)?.[0]?.value;

    const callback = data => {
      if (data) handleFormSubmit(new Event('submit'));
    };

    if (status !== undefined && item.id) {
      dispatch(actions.changeGiftRequest({ id: item.id, status }, callback));
    }
  };

  const activeItemsOnPage = state.itemsOnPage.filter(v => v.active)?.[0]?.value ?? 10;
  const pages = Math.ceil(count / activeItemsOnPage);

  useEffect(() => {
    handleFormSubmit(new Event('submit'));
  }, [state.page, state.itemsOnPage]);

  return {
    values: {
      state,
      items,
      pages,
      count,
      activeItemsOnPage,
      addressModalOpen,
    },
    handlers: {
      handlePageChange,
      handleItemsOnPageChange,
      handleUsernameChange,
      handleStatusChange,
      handleBeginDateChange,
      handleEndDateChange,
      handleDayChange,
      handleRequestChange,
      handleFormSubmit,
      setAddressModalOpen,
    },
  };
};

export default useGiftRequests;
